import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment } from "react";
import { isEmpty } from "lodash";
const FontAwesome = ({ icon, title, style }) => {
  return (
    <Fragment>
      <FontAwesomeIcon
        icon={icon}
        fixedWidth
        style={!isEmpty(style) ? style : null}
      />{" "}
      {!isEmpty(title) ? title : null}
    </Fragment>
  );
};

export default FontAwesome;
